import React, { Fragment, useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Ask(props) {
  const symbol_id = props.symbol_id;
  const socket = useContext(SocketContext);

  const [Ask, setAsk] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      if (Ask !== data.Ask) {
        setAsk(data.Ask);
      }
    }
  };

  return (
    <Fragment>
      <div className="bid">Ask</div>
      <div className="bidprice">
        {props.usdInr ? "$" : null}
        {props.usdInr ? parseFloat(Ask).toFixed(3) : Ask}
      </div>
    </Fragment>
  );
}
